import qs from 'querystring';

import getResponseJson from './getresponsejson';

const popoutCardService = serviceRoutes => {
  const init = encounterId => {
    const params = { encounterId };
    const queryString = qs.stringify(params);
    const url = `${serviceRoutes.init}?${queryString}`;

    return fetch(url, {
      credentials: 'include',
      method: 'GET'
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  return {
    init,
    serviceRoutes
  };
};

export default popoutCardService;
